// extracted by mini-css-extract-plugin
export var active = "_4r-7";
export var container = "_4r-0";
export var evenWidth = "_4r-4";
export var large = "_4r-5";
export var outlet = "_4r-8";
export var slide = "_4r-2";
export var small = "_4r-6";
export var tab = "_4r-3";
export var tabs = "_4r-1";